<template>
  <v-dialog :scrim="true" v-model="dialog" fullscreen>
    <template #activator="{ props }">
      <v-btn v-bind="props" color="primary"> Ajouter une pièce </v-btn>
    </template>

    <v-card>
      <v-toolbar>
        <v-btn icon="mdi-close" @click="dialog = false" />
        <v-toolbar-title>Add Inventory</v-toolbar-title>
      </v-toolbar>

      <v-card-text>
        <v-autocomplete
          label="Spare Part"
          :items="spareparts"
          item-title="displayName"
          v-model="selected"
          return-object
        />

        <v-text-field type="number" label="Quantity" v-model.number="quantity" />
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn @click="dialog = false">Annuler</v-btn>
        <v-btn color="primary" @click="add">Ajouter</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { getAllSpareparts } from "@/utils/sparepart-api";
import { postInventoryItem } from "@/utils/vehicle-api";
import { ref, onMounted } from "vue";

const props = defineProps({ vehicleId: Number });
const emit = defineEmits(["added"]);

const dialog = ref(false);
const spareparts = ref([]);
const selected = ref(null);
const quantity = ref(1);

onMounted(async () => {
  try {
    spareparts.value = await getAllSpareparts();
  } catch (error) {
    // Ignore
  }
});

const add = async () => {
  dialog.value = false;
  try {
    await postInventoryItem(props.vehicleId, {
      sparepartId: selected.value.id,
      quantity: quantity.value,
    });
  } catch (error) {
    // Ignore
  }

  emit("added", {
    sparepartId: selected.value.id,
    sparepartName: selected.value.name,
    quantity: quantity.value,
  });
};
</script>
